module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWN4FytrBQAFSAGjb3gnAgAAAABJRU5ErkJggg=="